import * as React from 'react';

import logger from 'js/app/loggerSingleton';

import ValuePropositionComponent, {
  type AdditionalContent,
} from 'bundles/browse-common/components/ValuePropositionComponent';
import { useDomainValueProposition } from 'bundles/browse-common/contexts/DomainValuePropositionContext';
import { usePageConfigComponentMetadata } from 'bundles/browse-common/contexts/PageConfigComponentMetadataContext';

const DomainValuePropositionRenderer = () => {
  const pageConfigMetadataContext = usePageConfigComponentMetadata();
  const domainValuePropositionContext = useDomainValueProposition();

  if (!pageConfigMetadataContext) {
    logger.warn('DomainValuePropositionRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  if (!domainValuePropositionContext) {
    logger.warn('DomainValuePropositionRenderer expected DomainValuePropositionContext');
    return null;
  }

  const { index } = pageConfigMetadataContext;
  const { domainValueProposition } = domainValuePropositionContext;

  if (!domainValueProposition) {
    return null;
  }

  const title = domainValueProposition.domain.name;
  const description = domainValueProposition.description;
  const additionalContent: AdditionalContent[] =
    domainValueProposition.valuePropositionItems?.map((item) => ({
      text: item.text || '',
    })) || [];

  return (
    <ValuePropositionComponent
      showPageTitleHeadingSize={index === 0}
      title={title}
      description={description}
      additionalContent={additionalContent}
    />
  );
};

export default DomainValuePropositionRenderer;
